import { render, staticRenderFns } from "./SetPeriodModal.vue?vue&type=template&id=528f277b&scoped=true&"
import script from "./SetPeriodModal.vue?vue&type=script&lang=ts&"
export * from "./SetPeriodModal.vue?vue&type=script&lang=ts&"
import style0 from "./SetPeriodModal.vue?vue&type=style&index=0&id=528f277b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528f277b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
